import { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { dangNhapGoogle, theoDoiDangNhap } from '../lib/auth.js';
import { layDb } from '../lib/firebase.js';
import { docTatCaBai } from '../lib/playbook.js';
import { docTatCaYeuCau, docBanNhapAI } from '../lib/nhanXetDeck.js';
import { chuanHoaNhanXet } from '@shared/nhanXetDeck.js';
import { docTatCaHoSo, luuHoSo, xoaHoSo } from '../lib/spotlightHoSo.js';
import { HO_SO_TRONG, HO_SO_VI_DU, formSangHoSo, hoSoSangForm, kiemTraHoSo, tenTepPdf, tuBaiSpotlight, tuNhanXet } from '../lib/spotlightModel.js';

/**
 * /admin/spotlight: soạn hồ sơ một trang gửi riêng cho quỹ và xuất PDF.
 *
 * Xem trước chính là file PDF sẽ tải về (dựng lại sau mỗi lần sửa), nên không
 * có chuyện màn hình một đằng, file một nẻo.
 */

const O = ({ label, value, onChange, rows, placeholder, rong }) => <div className={rong ? 'o-rong' : undefined}>
  <label>{label}</label>
  {rows
    ? <textarea rows={rows} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
    : <input type="text" value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />}
</div>;

export default function SpotlightAdmin() {
  const [user, setUser] = useState(null); const [allowed, setAllowed] = useState(false); const [checking, setChecking] = useState(true);
  const [ds, setDs] = useState([]); const [id, setId] = useState(''); const [form, setForm] = useState(() => hoSoSangForm(HO_SO_TRONG));
  const [bai, setBai] = useState([]); const [deck, setDeck] = useState([]); const [chonBai, setChonBai] = useState(''); const [chonDeck, setChonDeck] = useState('');
  const [msg, setMsg] = useState(''); const [pdfUrl, setPdfUrl] = useState(''); const [canhBaoPdf, setCanhBaoPdf] = useState([]); const [dangDung, setDangDung] = useState(false);
  const hen = useRef(null);

  useEffect(() => theoDoiDangNhap(async (next) => {
    setUser(next); setAllowed(false); setChecking(true);
    if (next) try { const db = await layDb(); const { doc, getDoc } = await import('firebase/firestore/lite'); const snap = await getDoc(doc(db, 'admins', next.uid)); setAllowed(['admin', 'editor'].includes(snap.exists() ? snap.data()?.role : '')); } catch { setAllowed(false); }
    setChecking(false);
  }), []);

  async function taiDs() { try { setDs(await docTatCaHoSo()); } catch (e) { setMsg(e.message); } }
  useEffect(() => {
    if (!allowed) return;
    taiDs();
    docTatCaBai().then((x) => setBai(x.filter((p) => p.storyType === 'spotlight'))).catch(() => {});
    docTatCaYeuCau().then((x) => setDeck(x.filter((y) => y.status !== 'tu_choi'))).catch(() => {});
  }, [allowed]);

  const hoSo = useMemo(() => formSangHoSo(form), [form]);
  const loi = useMemo(() => kiemTraHoSo(hoSo), [hoSo]);

  // Dựng lại PDF xem trước sau khi ngừng gõ 0,6 giây.
  useEffect(() => {
    if (!allowed) return undefined;
    clearTimeout(hen.current);
    hen.current = setTimeout(async () => {
      setDangDung(true);
      try {
        const { dungPdfSpotlight } = await import('../lib/pdfSpotlight.js');
        const r = await dungPdfSpotlight(hoSo);
        const url = URL.createObjectURL(new Blob([r.byte], { type: 'application/pdf' }));
        setPdfUrl((cu) => { if (cu) URL.revokeObjectURL(cu); return url; });
        setCanhBaoPdf(r.canhBao);
      } catch (e) { setMsg(`Không dựng được PDF: ${e.message}`); } finally { setDangDung(false); }
    }, 600);
    return () => clearTimeout(hen.current);
  }, [hoSo, allowed]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const setVong = (k, v) => setForm((f) => ({ ...f, vong: { ...f.vong, [k]: v } }));
  const setGoc = (k, v) => setForm((f) => ({ ...f, gocNhin: { ...f.gocNhin, [k]: v } }));
  const mo = (h, moiId = '') => { setForm(hoSoSangForm(h)); setId(moiId); };

  async function luu() {
    if (hoSo.viDu) { setMsg('Hồ sơ ví dụ không lưu. Bấm "Bỏ đánh dấu ví dụ" nếu muốn dùng làm hồ sơ thật.'); return; }
    if (!hoSo.ten) { setMsg('Cần tên startup trước khi lưu.'); return; }
    setMsg('Đang lưu…');
    try { const moi = await luuHoSo(id, hoSo); setId(moi); setMsg('Đã lưu. Hồ sơ chỉ quản trị xem được.'); taiDs(); } catch (e) { setMsg(e.message); }
  }
  async function xoa() {
    if (!id || !window.confirm(`Xoá hồ sơ "${hoSo.ten}"? Không khôi phục được.`)) return;
    try { await xoaHoSo(id); mo(HO_SO_TRONG); setMsg('Đã xoá hồ sơ.'); taiDs(); } catch (e) { setMsg(e.message); }
  }
  function napBai() {
    const p = bai.find((x) => x.slug === chonBai);
    if (!p) return;
    mo(tuBaiSpotlight(p, hoSo), id);
    setMsg(`Đã nạp phần công khai từ bài "${p.title}" vào các ô còn trống. Vòng đang gọi cần điền tay.`);
  }
  async function napDeck() {
    const yc = deck.find((x) => x.id === chonDeck);
    if (!yc) return;
    setMsg('Đang lấy nhận xét deck…');
    try {
      let goc = yc.status === 'da_gui' ? yc.ketQua : null;
      if (!goc) { const a = await docBanNhapAI(yc.id); goc = a?.banBienTap || a?.nhap; }
      if (!goc) { setMsg('Deck này chưa có nhận xét.'); return; }
      mo(tuNhanXet(chuanHoaNhanXet(goc), yc, hoSo), id);
      setMsg(`Đã nạp điểm và nhận xét deck của ${yc.congTy}${yc.status === 'da_gui' ? '' : ' (bản chưa gửi founder)'}. Biên tập lại cho quỹ đọc.`);
    } catch (e) { setMsg(e.message); }
  }
  function taiPdf() {
    if (!pdfUrl) return;
    const a = document.createElement('a');
    a.href = pdfUrl; a.download = tenTepPdf(hoSo); a.click();
  }

  if (checking) return <div className="surface section-space"><p>Đang kiểm tra quyền quản trị…</p></div>;
  if (!user) return <section className="surface admin-gate"><h1>Hồ sơ Startup Spotlight</h1><p>Đăng nhập bằng tài khoản quản trị.</p><button className="nut" onClick={() => dangNhapGoogle()}>Đăng nhập với Google</button></section>;
  if (!allowed) return <section className="surface admin-gate"><h1>Chưa có quyền quản trị</h1><p>Tài khoản <strong>{user.email}</strong> chưa nằm trong danh sách admin.</p><Link className="nut phu" to="/">Về trang chủ</Link></section>;

  return <div className="admin-playbook spotlight-admin">
    <header className="page-heading">
      <p className="eyebrow">Khu vực quản trị: <Link to="/admin/playbook">Playbook</Link>, Hồ sơ Spotlight, <Link to="/admin/nhan-xet-deck">Nhận xét deck</Link></p>
      <h1>Hồ sơ Startup Spotlight</h1>
      <p>Hồ sơ một trang gửi riêng cho quỹ: phần công khai lấy từ bài Spotlight, cộng vòng đang gọi và góc nhìn của fundraising.vn. Chỉ quản trị xem được; ra ngoài bằng file PDF.</p>
    </header>
    <div className="admin-layout">
      <aside className="surface admin-list">
        <div className="hang-nut">
          <button className="nut" onClick={() => { mo(HO_SO_TRONG); setMsg(''); }}>+ Hồ sơ mới</button>
          <button className="nut phu" onClick={() => { mo(HO_SO_VI_DU); setMsg('Đã điền hồ sơ ví dụ (startup hư cấu) để xem bố cục. PDF có dải cảnh báo, không lưu được.'); }}>Điền ví dụ</button>
        </div>
        <h2>Hồ sơ đã lưu</h2>
        {ds.length === 0 && <p className="nho">Chưa có hồ sơ nào.</p>}
        {ds.map((h) => <button className="admin-post-row" key={h.id} onClick={() => { mo(h, h.id); setMsg(''); }}>
          <strong>{h.ten}</strong><span>{[h.dot, h.giaiDoan].filter(Boolean).join(', ') || 'Chưa xếp đợt'}</span>
        </button>)}
      </aside>

      <div className="spotlight-cot">
        <section className="surface admin-editor">
          <fieldset className="admin-section">
            <legend>Nạp sẵn để khỏi gõ lại</legend>
            <div className="spotlight-nap">
              <select value={chonBai} onChange={(e) => setChonBai(e.target.value)} aria-label="Chọn bài Spotlight">
                <option value="">Chọn bài Spotlight trong Playbook…</option>
                {bai.map((p) => <option key={p.slug} value={p.slug}>{p.title}{p.status === 'DRAFT' ? ' (nháp)' : ''}</option>)}
              </select>
              <button type="button" className="nut phu" disabled={!chonBai} onClick={napBai}>Nạp phần công khai</button>
            </div>
            <div className="spotlight-nap">
              <select value={chonDeck} onChange={(e) => setChonDeck(e.target.value)} aria-label="Chọn deck đã nhận xét">
                <option value="">Chọn deck đã nhận xét…</option>
                {deck.map((y) => <option key={y.id} value={y.id}>{y.congTy}{y.vong ? `, ${y.vong}` : ''}{y.status === 'da_gui' ? '' : ' (chưa gửi)'}</option>)}
              </select>
              <button type="button" className="nut phu" disabled={!chonDeck} onClick={napDeck}>Nạp góc nhìn</button>
            </div>
            {hoSo.viDu && <p className="nho">Đang là hồ sơ ví dụ. <button type="button" className="text-button" onClick={() => set('viDu', false)}>Bỏ đánh dấu ví dụ</button></p>}
          </fieldset>

          <fieldset className="admin-section"><legend>Đầu trang</legend><div className="o-nhap admin-fields">
            <O label="Tên startup" value={form.ten} onChange={(v) => set('ten', v)} />
            <O label="Đợt" value={form.dot} placeholder="Đợt 01, quý IV/2026" onChange={(v) => set('dot', v)} />
            <O rong label="Câu định vị (tối đa 20 chữ)" value={form.dinhVi} onChange={(v) => set('dinhVi', v)} />
            <O label="Ngành" value={form.nganh} onChange={(v) => set('nganh', v)} />
            <O label="Giai đoạn" value={form.giaiDoan} onChange={(v) => set('giaiDoan', v)} />
            <O label="Trụ sở" value={form.truSo} onChange={(v) => set('truSo', v)} />
            <O label="Năm thành lập" value={form.thanhLap} onChange={(v) => set('thanhLap', v)} />
            <O label="Website" value={form.website} onChange={(v) => set('website', v)} />
            <O label="Link video demo (https)" value={form.linkDemo} onChange={(v) => set('linkDemo', v)} />
          </div></fieldset>

          <fieldset className="admin-section"><legend>Sản phẩm và tiến triển</legend><div className="o-nhap admin-fields">
            <O rong rows="3" label="Vấn đề (2 câu)" value={form.vanDe} onChange={(v) => set('vanDe', v)} />
            <O rong rows="3" label="Sản phẩm giải quyết thế nào (2 đến 3 câu)" value={form.giaiPhap} onChange={(v) => set('giaiPhap', v)} />
            <O rong rows="4" label="Chỉ số, tối đa 4 dòng: Giá trị | Nhãn | Thời điểm | Nguồn (tự khai hoặc đã đối chiếu)" placeholder="180 tr đ | Doanh thu định kỳ tháng | 09/2026 | đã đối chiếu" value={form.chiSoText} onChange={(v) => set('chiSoText', v)} />
          </div></fieldset>

          <fieldset className="admin-section"><legend>Đội ngũ</legend><div className="o-nhap admin-fields">
            <O rong rows="3" label="Tối đa 3 dòng: Họ tên | Vai trò | Vì sao hiểu bài toán" value={form.doiNguText} onChange={(v) => set('doiNguText', v)} />
            <O label="Số nhân sự toàn thời gian" value={form.soNhanSu} onChange={(v) => set('soNhanSu', v)} />
          </div></fieldset>

          <fieldset className="admin-section"><legend>Vòng đang gọi (không đăng công khai)</legend><div className="o-nhap admin-fields">
            <O label="Quy mô vòng" value={form.vong.quyMo} placeholder="600.000 USD" onChange={(v) => setVong('quyMo', v)} />
            <O label="Hình thức" value={form.vong.hinhThuc} placeholder="SAFE, cổ phần ưu đãi…" onChange={(v) => setVong('hinhThuc', v)} />
            <O label="Định giá hoặc cap" value={form.vong.dinhGia} onChange={(v) => setVong('dinhGia', v)} />
            <O label="Đã cam kết" value={form.vong.daCamKet} placeholder="150.000 USD từ 2 angel" onChange={(v) => setVong('daCamKet', v)} />
            <O label="Runway hiện tại" value={form.vong.runway} onChange={(v) => setVong('runway', v)} />
            <O rows="3" label="Dùng vốn, mỗi dòng: Mục | %" placeholder={'Sản phẩm | 45\nBán hàng | 35'} value={form.dungVonText} onChange={(v) => set('dungVonText', v)} />
          </div></fieldset>

          <fieldset className="admin-section"><legend>Góc nhìn fundraising.vn</legend><div className="o-nhap admin-fields">
            <O label="Điểm rubric (0 đến 100)" value={form.diemText} onChange={(v) => set('diemText', v.replace(/[^0-9]/g, ''))} />
            <O label="Ngày chấm" value={form.gocNhin.ngayCham} placeholder="dd/mm/yyyy" onChange={(v) => setGoc('ngayCham', v)} />
            <O rong rows="3" label="Điểm mạnh, mỗi dòng một ý (tối đa 3)" value={form.diemManhText} onChange={(v) => set('diemManhText', v)} />
            <O rong rows="3" label="Câu hỏi nên hỏi founder, mỗi dòng một câu (tối đa 3)" value={form.cauHoiText} onChange={(v) => set('cauHoiText', v)} />
            <O label="Email nhận yêu cầu kết nối" value={form.lienHe} onChange={(v) => set('lienHe', v)} />
          </div></fieldset>

          <div className="admin-actions">
            <button className="nut" onClick={luu}>Lưu hồ sơ</button>
            <button className="nut phu" disabled={!pdfUrl || dangDung} onClick={taiPdf}>Tải PDF</button>
            {id && <button type="button" className="text-button danger" onClick={xoa}>Xoá hồ sơ</button>}
          </div>
          <p role="status">{msg}</p>
        </section>

        <section className="surface spotlight-xem" aria-label="Xem trước PDF">
          <div className="section-bar"><h2>Xem trước PDF</h2><p>{dangDung ? 'Đang dựng…' : 'Đúng file sẽ tải về'}</p></div>
          {[...loi, ...canhBaoPdf].length > 0 && <ul className="spotlight-loi">{[...loi, ...canhBaoPdf].map((x) => <li key={x}>{x}</li>)}</ul>}
          {pdfUrl && <iframe title="Xem trước hồ sơ PDF" src={`${pdfUrl}#toolbar=0&view=FitH`} />}
          {pdfUrl && <p className="nho"><a href={pdfUrl} target="_blank" rel="noreferrer">Mở PDF ở tab mới</a> (điện thoại không hiện được khung xem trước).</p>}
        </section>
      </div>
    </div>
  </div>;
}
